import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
`;

export const ConsultaContainer = styled.div`
  margin-left: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;

  position: absolute;
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  hr {
    position: absolute;
    top: 220px;
    width: 1100px;
    border: 1px solid #e9e9e9;
  }
`;

export const FormContainer = styled.div`
  width: 1100px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  p {
    margin: 35px 0px;
    padding-left: 8px;
    color: var(--color-primary);
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
  }

  span {
    margin: 35px 0px;
    padding-left: 14px;
    color: #f30303;
    font-size: 14px;
    line-height: 16px;
    font-weight: 700;
  }
`;

export const InputBlock = styled.div`
  display: flex;
  align-items: center;

  .readOnly {
    cursor: not-allowed;
  }
`;

export const Button = styled.button`
  margin: 40px -535px;
  top: 1050px;
  bottom: -20px;
  border: 0;
  width: 235px;
  height: 50px;
  background: var(--color-primary);
  border-radius: 5px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
`;
